 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML02_COPYRIGH from '@/components/xhtml/02_Copyrigh'
 import XHTML01_TITLE_PA from '@/components/xhtml/01_Title_Pa'
 import XHTML03_DEDICATI from '@/components/xhtml/03_Dedicati'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_ACKNOWLE from '@/components/xhtml/05_Acknowle'
 import XHTML06_INTRODUC from '@/components/xhtml/06_Introduc'
 import XHTML07_ONE__BEN from '@/components/xhtml/07_One__Ben'
 import XHTML08_TWO__WAR from '@/components/xhtml/08_Two__War'
 import XHTML09_THREE__J from '@/components/xhtml/09_Three__J'
 import XHTML10_FOUR__FA from '@/components/xhtml/10_Four__Fa'
 import XHTML11_FIVE__HE from '@/components/xhtml/11_Five__He'
 import XHTML12_SIX__VLA from '@/components/xhtml/12_Six__Vla'
 import XHTML13_SEVEN__H from '@/components/xhtml/13_Seven__H'
 import XHTML14_EIGHT__S from '@/components/xhtml/14_Eight__S'
 import XHTML15_CONCLUSI from '@/components/xhtml/15_Conclusi'
 import XHTMLNOTES from '@/components/xhtml/notes'
 import XHTML16_INDEX from '@/components/xhtml/16_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_Acknowle",
 			"name" : "xhtml/05_Acknowle",
 			"component" : XHTML05_ACKNOWLE
 		},
 		{
 			"path" : "/xhtml/06_Introduc",
 			"name" : "xhtml/06_Introduc",
 			"component" : XHTML06_INTRODUC
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js